<template>
  <the-section :title="$t('ec-line009.purchaseInfo.title')" class="purchase-item-section">
    <el-row>
      <template>
        <purchase-items
          v-for="(item, index) in data"
          :ref="item.ref"
          :key="item.id"
          :data="item"
          :is-last-item="data.length === index + 1"
        ></purchase-items>
      </template>
      <p v-if="!data.length" class="text-center">
        {{ $t('common.messages.noPurchases') }}
      </p>
    </el-row>
    <div v-if="totalItems > 3" class="w-full mt-6 pb-6 flex justify-center">
      <el-button class="cancel-btn font-bold text-base lg:text-lg leading-normal" @click="showMorePurchaseHistory">
        {{ $t('ec-line009.purchaseInfo.showMore') }}
      </el-button>
    </div>
  </the-section>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
import PurchaseItems from '@/components/ec-line009/PurchaseItems.vue'

export default {
  name: 'PurchaseInformation',
  components: { TheSection, PurchaseItems },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    totalItems: {
      type: Number,
      default: () => 0,
    },
  },

  methods: {
    showMorePurchaseHistory() {
      this.$router.push({
        name: 'EC_LINE042',
      })
    },
  },
}
</script>
